<template>
  <span class="d-inline-flex">
    <v-btn
      size="small"
      variant="text"
      color="primary"
      :disabled="!canOpen"
      @click="openDialog"
    >
      <v-icon start>mdi-package-variant-plus</v-icon>
      {{ $t("ncrm.contracts.actions.addProduct") }}
    </v-btn>
    <NcrmDealWonHandoffDialog
      v-model="dialogOpen"
      mode="contract_append"
      :contract-id="normalizedContractId"
      :contract-number="contract?.contract_number"
      :deal-id="contract?.deal_id"
      :deal-name="resolvedDealName"
      :existing-contract-items="contractItems"
      :select-menu-props="selectMenuProps"
      @success="handleSuccess"
      @error="handleError"
    />
  </span>
</template>

<script>
import NcrmDealWonHandoffDialog from "@/components/ncrm/deals/NcrmDealWonHandoffDialog.vue";

const toPositiveId = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  const normalized = Math.trunc(parsed);
  return normalized > 0 ? normalized : 0;
};

export default {
  name: "NcrmContractAddProductAction",
  components: {
    NcrmDealWonHandoffDialog,
  },
  props: {
    contract: {
      type: Object,
      default: null,
    },
    contractId: {
      type: [String, Number],
      default: null,
    },
    contractItems: {
      type: Array,
      default: () => [],
    },
    dealNameFallback: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectMenuProps: {
      type: Object,
      default: null,
    },
  },
  emits: ["success", "notify"],
  data() {
    return {
      dialogOpen: false,
    };
  },
  computed: {
    normalizedContractId() {
      return toPositiveId(this.contractId || this.contract?.id);
    },
    resolvedDealName() {
      return this.contract?.deal_name || this.dealNameFallback;
    },
    canOpen() {
      const status = String(this.contract?.status || "").trim().toLowerCase();
      return Boolean(
        this.normalizedContractId &&
        toPositiveId(this.contract?.deal_id) &&
        (status === "draft" || status === "active") &&
        !this.loading
      );
    },
  },
  methods: {
    openDialog() {
      if (this.canOpen) {
        this.dialogOpen = true;
      }
    },
    handleSuccess(payload = {}) {
      const contractItemIds = (payload?.response?.data?.contract_items_created || [])
        .map((item) => toPositiveId(item?.id))
        .filter((value) => value > 0);
      this.dialogOpen = false;
      this.$emit("success", { ...payload, contractItemIds });
    },
    handleError(payload = {}) {
      this.$emit("notify", {
        message: payload?.message || this.$t("ncrm.contracts.messages.productAddError"),
        color: payload?.color || "error",
      });
    },
  },
};
</script>
